import './TestComponent.scss'

const TestComponent = () => {
  return <></>
}

export default TestComponent
